<template>
    <picture class="block absolute top-0 left-0 w-full h-full" v-if="image">
        <source
            type="image/webp"
            :data-srcset="`${image.url}.webp 1440w,
                ${image.sizes.large}.webp 1024w,
                ${image.sizes.large}.webp 600w,
                ${image.sizes.medium_large}.webp 320w`">
        <source
            :type="`${image.mime_type}`"
            :data-srcset="`${image.url} 1440w,
                ${image.sizes.large} 1024w,
                ${image.sizes.large} 600w,
                ${image.sizes.medium_large} 320w`">
        <img class="lazyload lazyload-fade-in w-full h-full object-cover object-center"
             data-expand="150"
             :alt="`${image.alt}`">
    </picture>
</template>

<script>
export default {
    props: {
        image: {
            type: [Array, Object],
            default: [],
        }
    }
}
</script>